export function chunkArray<T>(array: T[], pageSize: number): T[][] {
  const result: T[][] = [];
  for (let i = 0; i < array.length; i += pageSize) {
    result.push(array.slice(i, i + pageSize));
  }
  return result;
}
